"use client";

import { READING_SERIES_ID_KEY, READING_SERIES_INDEX_KEY } from "app/constants";
import { useEffect } from "react";

export function ContentElementRead({
  episodeId,
  seriesIndexId,
  seriesHash,
}: {
  episodeId: string;
  seriesIndexId?: number;
  seriesHash?: string;
}) {
  useEffect(() => {
    fetch(`/api/episodes/${episodeId}/read`, { method: "post" });

    //series index id（おすすめ生成用）
    if (seriesIndexId) {
      const readingSeries = window.localStorage.getItem(READING_SERIES_INDEX_KEY);
      const storage = readingSeries ? JSON.parse(readingSeries) : [];
      let newStorage: number[];
      if (Array.isArray(storage)) {
        newStorage = storage.filter((id) => id !== seriesIndexId).slice(0, 9);
      } else {
        newStorage = [];
      }
      newStorage.unshift(seriesIndexId);
      window.localStorage.setItem(READING_SERIES_INDEX_KEY, JSON.stringify(newStorage));
    }

    //series id（非ユーザむけ既読シリーズ表示用）
    if (seriesHash) {
      const readingSeries = window.localStorage.getItem(READING_SERIES_ID_KEY);
      const storage = readingSeries ? JSON.parse(readingSeries) : [];
      let newStorage: string[];
      if (Array.isArray(storage)) {
        newStorage = storage.filter((id) => id !== seriesHash).slice(0, 9);
      } else {
        newStorage = [];
      }
      newStorage.unshift(seriesHash);
      window.localStorage.setItem(READING_SERIES_ID_KEY, JSON.stringify(newStorage));
    }
  }, [episodeId, seriesIndexId, seriesHash]);
  return <></>;
}
